// extracted by mini-css-extract-plugin
module.exports = {"CalculatorBody":"Calculator_CalculatorBody__3GOGi","Keypad":"Calculator_Keypad__3u5sz","KeypadRow":"Calculator_KeypadRow__1Ue3x"};